export const CoreApi = "CoreApi"

const User = "User/";
export const SearchUsers = User + 'SearchUsers';
export const GetUserById = User;
export const Insert = User + 'Insert';
export const Update = User + 'Update';
export const UserForgotPassword = User + 'UserForgotPassword';
export const Delete = User;
export const GetUserRoles = User + 'GetUserRoles';
export const GetAllRoles = User + 'GetAllRoles';
export const SaveUserRoles = User + 'SaveUserRoles';
export const GetAllUsers = User + 'All';
export const GetNonAdminUsers = User + 'NonAdmin'
export const GetNonClientUsers = User + 'NonClient'
export const GetVerificationAgency = User + 'VerificationAgency'